import Head from "next/head";

import CustomCard from "components/CustomCard";
import useAuthentication from "hooks/useAuthentication";

import DashboardPageInsightList from "../DashboardPageInsightList";

type DashboardPageAllInsightsProps = {};

const DashboardPageAllInsights = ({}: DashboardPageAllInsightsProps) => {
  const { authenticated } = useAuthentication();

  const tabContent = (
    <DashboardPageInsightList
      options={{
        showFilters: true,
        showTopPicksToggle: true,
        showSorter: true,
        showSearch: true,
        showPresets: authenticated,
      }}
    />
  );

  const title = "Browse | Smartkarma";

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta property="og:title" content={title} />
      </Head>
      <CustomCard className={"mt-[45px] p-0"}>{tabContent}</CustomCard>
    </>
  );
};

export default DashboardPageAllInsights;
